import { Database } from "lucide-react";

const METRICS = [
  { key: "total", label: "Total Deals", filter: {} },
  { key: "missing_address", label: "Missing Address", filter: { missing: "address" } },
  { key: "missing_price", label: "Missing Price", filter: { missing: "price" } },
  { key: "missing_listing_type", label: "Missing Listing Type", filter: { missing: "listing_type" } },
  { key: "missing_asset_class", label: "Missing Asset Class", filter: { missing: "asset_class" } },
  { key: "missing_location", label: "Missing Location", filter: { missing: "location" } },
  { key: "duplicate_candidates", label: "Duplicate Candidates", filter: { duplicates: true } },
  { key: "out_of_scope", label: "Out-of-Scope", filter: { out_of_scope: true } },
  { key: "restricted_housing", label: "Restricted Housing", filter: { restricted: true } },
  { key: "ai_score_missing", label: "AI Score Missing", filter: { ai_missing: true } },
  { key: "score_disagreements", label: "Score Disagreements", filter: { disagreement: true } },
];

export const DiDiagnostics = ({ diagnostics, loading, error, onPick, active }) => (
  <section className="rounded-xl border border-slate-200 bg-white p-4" data-testid="di-diagnostics">
    <div className="flex items-center justify-between mb-3">
      <h2 className="text-sm font-bold text-[#0A2342] flex items-center gap-2"><Database className="w-4 h-4 text-[#C8A96B]" /> Data Quality</h2>
      {diagnostics && <span className="text-xs text-slate-400">Scoring v{diagnostics.scoring_version}</span>}
    </div>
    {error && <p className="text-sm text-red-600" data-testid="di-diagnostics-error">{error}</p>}
    {loading && !diagnostics && <div className="h-16 rounded-lg bg-slate-100 animate-pulse" />}
    {diagnostics && (
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 xl:grid-cols-11 gap-2">
        {METRICS.map((m) => {
          const v = diagnostics[m.key] ?? 0;
          const warn = m.key !== "total" && v > 0;
          return (
            <button key={m.key} type="button" onClick={() => onPick(m.filter)} data-testid={`di-diag-${m.key}`}
              className={`text-left rounded-lg border px-3 py-2 transition-colors ${active === m.key ? "border-[#C8A96B] bg-[#C8A96B]/10" : "border-slate-200 hover:bg-slate-50"}`}>
              <div className={`text-lg font-bold ${warn ? "text-amber-700" : "text-[#0A2342]"}`}>{v}</div>
              <div className="text-[11px] leading-tight text-slate-500">{m.label}</div>
            </button>
          );
        })}
      </div>
    )}
  </section>
);
